<mat-card>
    <mat-tab-group selectedIndex="0" (selectedTabChange)="changeTab($event)" *ngIf="editable; else elseBlock;">
        <mat-tab *ngFor="let lg of languages; let i = index" label="{{lg}}">
            <app-editor *ngIf="tabIndex === i" [language]="lg" [filePath]="chosenFilePath !== '\\' ? 
            chosenFilePath.substring(chosenFilePath.lastIndexOf('\\')+1) : chosenFilePath" [editable]="editable"></app-editor>
        </mat-tab>
    </mat-tab-group>
    <ng-template #elseBlock><app-editor [editable]="editable" [language]="selectedLanguage"  [filePath]="chosenFilePath"></app-editor></ng-template>
</mat-card>